import coreIconLabMetadata from '@atlaskit/icon-lab/metadata';
import coreIconMetadata from '@atlaskit/icon/metadata-core';

import { getIconName } from './get-icon-name';
import { type NewCoreIconData } from './types';

export const getIcon: (
	location: string,
	name: string,
) => Promise<NewCoreIconData | undefined> = async (location: string, name: string) => {
	if (location === '@atlaskit/icon') {
		const icon = await import(
			/* webpackChunkName: "@atlaskit-internal_[request]" */ `@atlaskit/icon/core/${name}`
		);
		const metadata = coreIconMetadata[name];
		const data: NewCoreIconData = {
			key: name,
			keywords: metadata.keywords,
			component: icon.default,
			componentName: metadata.componentName,
			packageName: metadata.package,
			iconName: getIconName(name),
			categorization: metadata.categorization,
			usage: metadata.usage,
			team: metadata.team,
		};
		return data;
	} else if (location === '@atlaskit/icon-lab') {
		const icon = await import(
			/* webpackChunkName: "@atlaskit-internal_[request]" */ `@atlaskit/icon-lab/core/${name}`
		);
		const metadata = coreIconLabMetadata[name];
		const data: NewCoreIconData = {
			key: name,
			keywords: metadata.keywords,
			component: icon.default,
			componentName: metadata.componentName,
			packageName: metadata.package,
			iconName: getIconName(name),
			categorization: metadata.categorization,
			usage: metadata.usage,
			team: metadata.team,
		};
		return data;
	}
};
